import { inject, ChangeDetectorRef, Component, Inject, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Splash } from "../../../Akte/Controlls/Splash";
import { KooperationsPartner, LegsEintrag, Leistung } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { AdminCard } from "../Sonstige/AdminCard";
import { AddressEdit } from "../../../Akte/Controlls/AddressEdit";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";

import { LegsEdit } from '../../Popups/LegsEdit'
import { LegsHist } from "../../Popups/LegsHist";
import {Abteilung} from '../../Popups/abteilung/abteilung';
import {AbteilungsModel} from '../../../Api/DcoApi/Admin/AdminClasses';

@Component({
  imports: [
    CommonModule,
    Splash,
    AddressEdit,
    FormsModule, AdminCard
  ],
  selector: 'KooperationspartnerEdit',
  templateUrl: './KooperationspartnerEdit.html',
  standalone: true,
  styleUrl: './KooperationspartnerEdit.css'
})
export class KooperationspartnerEdit implements OnInit {
  toastService: ToastService;
  ngOnInit(): void {
    this.GetData();
  }

  constructor(private cdr: ChangeDetectorRef) {
    this.toastService = inject(ToastService)
  }

  @Input() Key?: string | null = null;

  Client: RestClient = new RestClient();

  Entry: KooperationsPartner | null = null;

  Abbrechnungcentren = [
    { Key: 0 , Value: "..." },
    { Key: 1, Value: "RZH" },
    { Key: 2, Value: "AS Bremen" },
    { Key: 3, Value: "Optica" },
    { Key: 4, Value: "DMRZ" },
    { Key: 5, Value: "OptaData" },
    { Key: 6, Value: "BFS" },
    { Key: 7, Value: "Kassenabrechnung" },
    { Key: 8, Value: "DZH" },
    { Key: 9, Value: "Noventi" }
  ]

  LeistungList: Leistung[] = [];
  Partner: KooperationsPartner[] = [];

  isChecked(partnerKey: number): boolean {
    return this.Entry?.allowdAccesForDevices?.includes(partnerKey) ?? false;
  }

  // Die Hauptfunktion zum Setzen/Entfernen der Werte
  onCheckboxChange(event: any, partnerKey: number) {
    if (this.Entry) {
      if (!this.Entry?.allowdAccesForDevices || this.Entry?.allowdAccesForDevices == null)
        this.Entry.allowdAccesForDevices = [];

      if (event.target.checked) {
        this.Entry?.allowdAccesForDevices?.push(partnerKey);
      } else {
        this.Entry.allowdAccesForDevices = this.Entry?.allowdAccesForDevices?.filter(
          (id) => id !== partnerKey
        ) ?? [];
      }
    }
  }

  AddNewAbteilung() {
    var model = this.modalService.open(Abteilung,{ size: 'sm' });
    model.closed.subscribe(async (s) => {
      if(s && s !== null && s !== undefined && s !== "")
      {
        this.Entry =   await this.Client.Put<KooperationsPartner, AbteilungsModel>(`/Backend/Api/V2/Admin/KooperationsPartner/${this.Key}/Abteilung`, { name: s } as AbteilungsModel);
        this.cdr.detectChanges();
      }
    });
  }

  async GetData() {
    if (!this.Key || this.Key == null || this.Key == "0" || isNaN(Number(this.Key)))
      this.Entry = {
        key: 0, stammdaten: {}, leistung: {}, abrechnungszentrum: {}, ekv: {}
      } as KooperationsPartner;
    else
      this.Entry = await this.Client.Get<KooperationsPartner>(`/Backend/Api/V2/Admin/KooperationsPartner/${this.Key}`);

    this.LeistungList = await this.Client.Get<Leistung[]>("/Backend/Api/V2/Admin/Leistung?PageSize=0")
    this.Partner = await this.Client.Get<KooperationsPartner[]>("/Backend/Api/V2/Admin/KooperationsPartner?PageSize=0")
    this.cdr.detectChanges();
  }

  async SaveData() {
    if (this.Entry && this.Entry !== null) {
      if (this.Entry.key == 0)
        this.Entry =  await this.Client.Post<KooperationsPartner, KooperationsPartner>("/Backend/Api/V2/Admin/KooperationsPartner", this.Entry);
      else
        this.Entry =   await this.Client.Put<KooperationsPartner, KooperationsPartner>(`/Backend/Api/V2/Admin/KooperationsPartner`, this.Entry);
      this.toastService.show({ template: this.successTpl, classname: 'bg-success text-light show', delay: 10000 })
    }
  }

  get CurrentLegs(): LegsEintrag[] {
    if (!this.Entry || this.Entry == null || !this.Entry.legs || this.Entry.legs == null)
      return [];

    return this.Entry.legs.filter(o => o.gueltigBis == null || o.gueltigBis == undefined);
  }

  private modalService = inject(NgbModal);

  AddUpdateLegs(legs: LegsEintrag | null | undefined) {
    if (!this.Entry || this.Entry == null || !this.Entry.legs || this.Entry.legs == null)
      return;

    var modal = this.modalService.open(LegsEdit)
    modal.componentInstance.PG = legs?.pg ?? 0;
    modal.componentInstance.Legs = legs?.legs ?? "";
    modal.componentInstance.Key = this.Entry.key;
    modal.closed.subscribe({
      next: async (legs) => {

          if (!(!this.Entry || this.Entry == null || !this.Entry.legs || this.Entry.legs == null)) {
            var entry = await this.Client.Get<KooperationsPartner>(`/Backend/Api/V2/Admin/KooperationsPartner/${this.Key}`);
            this.Entry.legs = entry.legs;
            this.cdr.detectChanges();
          }


      },
      error: (err) => {

      },
    });
  }

  OpenLegsHistory(pg: number | null | undefined) {
    if (!this.Entry || this.Entry == null )
      return;
    var modal = this.modalService.open(LegsHist)
    modal.componentInstance.Items = this.Entry.legs.filter(o => o.pg == pg);

    modal.closed.subscribe({
      next: async (config) => {

      },
      error: (err) => {


      },
    });
  }

  @ViewChild('successTpl') public successTpl!: TemplateRef<any>;
}
